import { useCallback } from "react";
import { container } from "tsyringe";
import ProjectResponseResource from "common/resources/Project/ProjectResponseResource";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import Modal from "components/elements/Modal";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import ProjectServiceAdmin from "services/admin/ProjectService";
import ProjectService from "services/ProjectService";
import classes from "./classes.module.scss";
import { XMarkIcon } from "@heroicons/react/24/solid";

type IProps = {
	project: ProjectResponseResource | null;
	isOpen: boolean;
	onClose: () => void;
	onAnchorProject: () => Promise<void> | void;
	isAdmin: boolean;
};

const projectServiceAdmin = container.resolve(ProjectServiceAdmin);
const projectService = container.resolve(ProjectService);

export default function AnchorProjectModal(props: IProps) {
	const anchorProject = useCallback(async () => {
		if (!props.project) return;
		if (props.isAdmin) {
			await projectServiceAdmin.createAnchor(props.project.id);
		} else {
			await projectService.createAnchor(props.project.id);
		}
		await props.onAnchorProject();
		props.onClose();
	}, [props]);

	return (
		<Modal className={classes["root"]} isOpen={props.isOpen} onClose={props.onClose}>
			<div className={classes["anchor-modal"]}>
				<div className={classes["title-container"]}>
					<Typography type="h1" weight="bold" className={classes["title"]}>
						{I18n.asset.pages.my_projects.drawer.modal.title}
					</Typography>
					<XMarkIcon className={classes["close-icon"]} onClick={props.onClose} />
				</div>
				<Typography type="p" size="medium" weight="regular">
					{I18n.asset.pages.my_projects.drawer.modal.content1}&nbsp;
					<Typography type="span" size="medium" weight="bold">
						{I18n.asset.pages.my_projects.drawer.modal.content2}&nbsp;
					</Typography>
					{I18n.asset.pages.my_projects.drawer.modal.content3}
				</Typography>
				<Typography type="p" size="medium" weight="regular">
					{I18n.asset.pages.my_projects.drawer.modal.content4}
				</Typography>
				<div className={classes["button-container"]}>
					<Button color={EButtonColor.PRIMARY} variant={EButtonVariant.OUTLINED} onClick={props.onClose} fullwidth>
						<Typography type="span" size="medium" weight="regular">
							{I18n.asset.pages.my_projects.drawer.modal.button.cancel}
						</Typography>
					</Button>
					<Button color={EButtonColor.PRIMARY} variant={EButtonVariant.CONTAINED} onClick={anchorProject} fullwidth>
						<Typography type="span" size="medium" weight="regular">
							{I18n.asset.pages.my_projects.drawer.button.anchor}
						</Typography>
					</Button>
				</div>
			</div>
		</Modal>
	);
}
